<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
const flagsStore = useFlagsStore()
const appStore = useAppStore()

await callOnce('app-init', async () => {
  await Promise.all([
    flagsStore.fetchFlags(),
    appStore.fetchCountries()
  ])
})

const { $htmlLang, $hrefLangLinks } = useNuxtApp()

useHead({
  htmlAttrs: {
    lang: $htmlLang
  },
  link: $hrefLangLinks
})
</script>
